import React from 'react';
import { TableComponentsProps } from '../table-components.props';

export const CarClass = ({ row }: TableComponentsProps): JSX.Element=> {
  const carClass = row && row.uds_poolcar_classid;

  return (
    <span>
      {carClass || '-'}
    </span>
  );
};
